export function ExportPage(objects, payrollData) {
  if (payrollData.length === 0) {
    console.error("No payroll data to export");
    return;
  }

  const lines = payrollData.map((payroll) => {
    const employeeId = payroll?.employee?.id;
    const matchedEmployee = objects.find((obj) => obj.id === employeeId);

    const accountNumber = matchedEmployee?.accountNumber ?? "";
    const surname = matchedEmployee?.surname ?? "";
    const firstName = matchedEmployee?.Firstname ?? "";

    const firstColumnRaw = `${accountNumber}${surname} ${firstName}`;
    const firstColumn = firstColumnRaw.slice(0, 49).padEnd(49, " ");

    const formattedNetSalary = ((payroll?.netAmount || 0) * 100)
      .toFixed(0)
      .padStart(7, "0");

    const accSuffix = matchedEmployee
      ? `${accountNumber.slice(0, 3)}${String(7).padStart(5, "0")}`
      : "00000000";

    const secondColumnRaw = `00000000${formattedNetSalary}${accSuffix}`;
    const secondColumn = secondColumnRaw.slice(0, 30).padEnd(30, " ");

    return `${firstColumn}\t${secondColumn}`;
  });

  const finalDataToExport = lines.join("\n");

  const now = new Date();
  const dateStr = now
    .toISOString()
    .replace(/T/, "_")
    .replace(/\..+/, "")
    .replace(/:/g, "_");

  const fileName = `FINDES_PAYROLL_${dateStr}.txt`;

  const blob = new Blob([finalDataToExport], { type: "text/plain" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
